import { Box, Flex } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const shimmerStyle = {
  borderRadius: '12px',
  background: 'linear-gradient(90deg, #EFECF9 25%, #F7F5FC 37%, #EFECF9 63%)',
  backgroundSize: '800px 100%',
  animation: `${shimmer} 1.6s ease-in-out infinite`,
};

const DashboardSkeletonLoader = () => {
  return (
    <Flex
      direction='column'
      gap='16px'
      p='24px'
      height='100%'
      width='100%'
      bg='linear-gradient(180deg, #FCFAF8 14.669%, #F5F2FF 48.801%, #FFF0FC 100%)'
    >
      {/* Header row: title + date pill */}
      <Flex justify='space-between' align='center'>
        <Box {...shimmerStyle} height='28px' width='220px' />
        <Box {...shimmerStyle} height='28px' width='140px' />
      </Flex>

      {/* Pages strip */}
      <Flex gap='8px'>
        <Box {...shimmerStyle} height='34px' width='90px' />
        <Box {...shimmerStyle} height='34px' width='90px' />
        <Box {...shimmerStyle} height='34px' width='90px' />
      </Flex>

      {/* Widget grid */}
      <Flex gap='16px' flex='1' minH='0'>
        <Flex direction='column' gap='16px' flex='1'>
          <Box {...shimmerStyle} flex='1' />
          <Box {...shimmerStyle} flex='1' />
        </Flex>
        <Flex direction='column' gap='16px' flex='1'>
          <Box {...shimmerStyle} flex='2' />
          <Box {...shimmerStyle} flex='1' />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DashboardSkeletonLoader;
